import {
  join
} from '../../../lib/Array.lib';

export default function Row({ className, show = true, ...props }) {
  return show && (
    <div className={join(['row d-flex space-between w-100', className], ' ')} {...props} />
  )
}
